import { render, staticRenderFns } from "./review-borrower.vue?vue&type=template&id=e3144766&"
import script from "./review-borrower.vue?vue&type=script&lang=ts&"
export * from "./review-borrower.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports